import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
// Styled Components

// Estilo para el hero con la imagen de fondo
const HeroC = styled.header`
  position: relative;
  background-image: url("./img/banners/carrousel.webp"); /* Cambia por la ruta de tu imagen */
  background-size: cover;
  background-position: center;
  height: 400px; /* Altura del header */
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Superposición oscura para mejorar legibilidad
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Oscurece la imagen */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 20px;
`;

// Estilo del título
const Title = styled.h1`
  font-size: 2.5rem;
  margin: 0;
`;

// Estilo para el breadcrumb
const Breadcrumb = styled.p`
  font-size: 1rem;
  margin: 10px 0 0;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const LinkCustom = styled(Link)`
  color: #fff;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

const Hero = ({title}) => {
  return (
    <HeroC>
      <Overlay>
        <Title>{title}</Title>
        <Breadcrumb>
          <LinkCustom to="/">Home</LinkCustom> / {title}
        </Breadcrumb>
      </Overlay>
    </HeroC>
  );
};

export default Hero;
